"use client"

import type React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { Btn } from "../../../AbstractElements"
import { useNavigate, useLocation } from "react-router-dom"
import { FaExclamationTriangle, FaUserEdit, FaTimes } from "react-icons/fa"

interface ProfileCompletionModalProps {
  isOpen: boolean
  onClose?: () => void
}

const ProfileCompletionModal: React.FC<ProfileCompletionModalProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate()
  const location = useLocation()

  // Check if user is on profile edit page
  const isOnProfilePage = location.pathname.includes("/users/useredit") || location.pathname.includes("/users/userprofile")

  const handleGoToProfile = () => {
    navigate(`${process.env.PUBLIC_URL}/users/useredit`)
  }

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  // Don't show modal if user is on profile page
  if (!isOpen || isOnProfilePage) {
    return null
  }

  return (
    <Modal isOpen={isOpen} backdrop="static" keyboard={false} centered>
      <ModalHeader className="bg-success text-white border-0">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex align-items-center">
            <FaExclamationTriangle className="me-2" size={20} />
            Profile Completion Required
          </div>
          {/* Allow closing only on profile page */}
          {isOnProfilePage && (
            <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={handleClose}>
              <FaTimes size={14} />
            </button>
          )}
        </div>
      </ModalHeader>
      <ModalBody className="p-4">
        <div className="text-center mb-4">
          <div className="bg-success bg-opacity-10 p-3 rounded-circle d-inline-flex mb-3">
            <FaUserEdit size={40} className="text-warning" />
          </div>
          <h4 className="mb-3">Your profile is incomplete</h4>
          <p className="mb-0">
            You need to complete your profile information before you can continue using the system. Please add your
            identification document information to proceed.
          </p>
        </div>
      </ModalBody>
      <ModalFooter className="border-0 justify-content-center">
        <Btn color="success" size="lg" onClick={handleGoToProfile} className="px-2">
          Complete My Profile
        </Btn>
      </ModalFooter>
    </Modal>
  )
}

export default ProfileCompletionModal
